import React from 'react';
import {MenuItem} from '@mui/material';
import CustomFormControl from '../../Dropdown/CustomFormControl';

const AlertLevelSelector = ({ value, onChange, campaignLevel = false, alertMetasearchBudget = false, isAdminOrMainUser, error }) => {
    const levels = [
        ...(!(alertMetasearchBudget && !isAdminOrMainUser) ? [{ label: 'Account', value: 'ACCOUNT' }] : []),
        { label: 'Hotel', value: 'HOTEL' },
        ...((campaignLevel && isAdminOrMainUser) ? [{ label: 'Campaign', value: 'CAMPAIGN' }] : []),
        ...(isAdminOrMainUser ? [{ label: 'Group', value: 'GROUP' }] : [])
    ];

    return (
        <div className="alert-level-container">
            <label>ALERT LEVEL</label>
            <CustomFormControl
                value={value}
                onChange={onChange}
                displayEmpty
                required
                error={error}
                helperText={error ? "This field is required" : ""}
                renderValue={(selected) =>
                    selected
                        ? levels.find(l => l.value === selected)?.label
                        : <span style={{ fontSize: "12px", color: "#bab7b7" }}>Alert Level</span>
                }
            >
                <MenuItem disabled value="">
                    <span style={{ fontSize: "12px", color: "black" }}>Alert Level</span>
                </MenuItem>
                {levels.map(l => (
                    <MenuItem key={l.value} value={l.value} sx={{ fontSize: "12px", color: "black" }}>
                        {l.label}
                    </MenuItem>
                ))}
            </CustomFormControl>
        </div>
    );
};

export default AlertLevelSelector;
